import React, { useState, useEffect } from 'react';
import { Box, Grid, TablePagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import SaveButton from '../../Common_Components/SaveButton';
import ResetButton from '../../Common_Components/ResetButton';
import axiosInstance from '../../axios/axios';
import moment from 'moment/moment';
import CustomSelectBox from '../../Common_Components/CustomSelectBox';
import CustomInputField from '../../Common_Components/CustomInputField';
const style = {
    fontFamily: 'Times New Roman',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '18.4px',
    color: '#000000',
    alignItems: 'center',
};
const LicenseReport = () => {
    const [filters, setFilters] = useState({
        startDate: '',
        endDate: ''
    });
    const [licenseReport, setLicenseReport] = useState([]);
    const [clientLists, setClientLists] = useState([])
    const [selectedClient, setSelectedClient] = useState(null)
    const [productLists, setProductLists] = useState([])
    const [selectedProduct, setSelectedproduct] = useState(null)
    const [licenseTypeLists, setLicenseTypeList] = useState([])
    const [licenseType, setLicenseType] = useState(null)
    const [status, setStatus] = useState(null)
    const [dateRangeType, setdateRangeType] = useState(null)
    const statusList = [
        { id: 1, label: 'Issued' },
        { id: 2, label: 'Activated' },
        { id: 3, label: 'Expired' }
    ];
    const daterangeList = [
        { id: "today", label: 'Today' },
        { id: "this_month", label: 'This Month' },
        { id: "this_year", label: 'This Year' },
        { id: "custom", label: 'Custom' }
    ];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    useEffect(() => {
        const getClientList = async () => {
            const response = await axiosInstance.post('/clients/clientList')
            const { success, clients } = response.data
            if (success === true) {
                const vals = clients && clients.map((val) => {
                    return { id: val.CD_Id, label: val.CD_Name }
                })
                setClientLists(vals)
            } else {
                setClientLists([])
            }
        }
        const getProductList = async () => {
            const response = await axiosInstance.post('/product/List')
            const { success, products } = response.data
            if (success === true) {
                const vals = products && products.map((val) => {
                    return { id: val.PD_Id, label: val.PD_Name }
                })
                setProductLists(vals)
            } else {
                setProductLists([])
            }
        }
        const fetchLicenseTypes = async () => {
            try {
                const response = await axiosInstance.get('/common/licenseTypes');
                const { success, LicenseTypeList } = response.data
                if (success === true) {
                    const vals = LicenseTypeList && LicenseTypeList.map((val) => {
                        return { id: val.LT_Id, label: val.LT_Name }
                    })
                    setLicenseTypeList(vals)
                } else {
                    setLicenseTypeList([])
                }
            } catch (error) {
                console.error('Error fetching countries:', error);
                // Toast.error('Failed to fetch countries.');
            }
        };
        getProductList()
        getClientList()
        fetchLicenseTypes()
    }, [])
    const fetchLicenseReport = async () => {
        const filtersreq = {
            clientId: selectedClient?.id,
            productId: selectedProduct?.id,
            licenseType: licenseType?.id,
            status: status?.id,
            dateRangeType: dateRangeType?.id,
            startDate: filters.startDate,
            endDate: filters.endDate
        }
        try {
            const response = await axiosInstance.post('/licenses/licenseReport', filtersreq);
            const { success, report } = response.data
            if (success) {
                setLicenseReport(report.data);
            } else {
                setLicenseReport([]);
            }

        } catch (error) {
            console.error("Error fetching license report:", error);
        }
    };
    const fetchLicenseReportReset = async () => {

        try {
            const response = await axiosInstance.post('/licenses/licenseReport');
            const { success, report } = response.data
            if (success) {
                setLicenseReport(report.data);
            } else {
                setLicenseReport([]);
            }

        } catch (error) {
            console.error("Error fetching license report:", error);
        }
    };
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleSearch = () => {
        fetchLicenseReport();
    };

    const handleReset = () => {
        setSelectedClient(null)
        setSelectedproduct(null)
        setLicenseType(null)
        setdateRangeType(null)
        setStatus(null)
        setFilters({
            startDate: '',
            endDate: ''
        });
        fetchLicenseReportReset();
    };

    useEffect(() => {
        fetchLicenseReport(); // Fetch today's data initially
    }, []);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <Box sx={{ padding: 3 }}>
            <h2 className='roletitle'>License Report</h2>
            <Grid container spacing={2} mb={3}>
                <Grid item xs={12} md={2}>
                    <CustomSelectBox
                        label="Client"
                        options={clientLists}
                        Value={selectedClient}
                        setValue={setSelectedClient}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <CustomSelectBox
                        label="Product"
                        options={productLists}
                        Value={selectedProduct}
                        setValue={setSelectedproduct}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <CustomSelectBox
                        label="License Type"
                        options={licenseTypeLists}
                        Value={licenseType}
                        setValue={setLicenseType}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <CustomSelectBox
                        label="Status"
                        options={statusList}
                        Value={status}
                        setValue={setStatus}
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <CustomSelectBox
                        label="Issued Date"
                        options={daterangeList}
                        Value={dateRangeType}
                        setValue={setdateRangeType}
                    />
                </Grid>
                {dateRangeType?.id === 'custom' && (
                    <>
                        <Grid item xs={12} md={2}>
                            <CustomInputField
                                type="date"
                                label="Start Date"
                                name="startDate"
                                value={filters.startDate}
                                onChange={handleFilterChange}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CustomInputField
                                type="date"
                                label="End Date"
                                name="endDate"
                                value={filters.endDate}
                                onChange={handleFilterChange}
                                fullWidth
                            />
                        </Grid>
                    </>
                )}
                <Grid
                    container
                    item
                    xs={12}
                    md={2}
                    sx={{ mt: 4 }}
                    alignItems="center"
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "left", // Controls button placement
                            gap: 2, // Minimal gap between buttons
                            width: "100%",
                        }}
                    >
                        <SaveButton label="Search" onClick={handleSearch} fullWidth={false} />
                        <ResetButton label="Reset" onClick={handleReset} fullWidth={false} />
                    </Box>
                </Grid>
            </Grid>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead style={{ backgroundColor: '#EEDEFF' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Client Name</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Product Name</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Product Version</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>License Type</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>User Count</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Issued Date</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Expiry Date</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {licenseReport.length > 0 ? (
                            licenseReport.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => (
                                    <TableRow key={index} style={{ backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#DAD9D9' }}>
                                        <TableCell sx={style}>{index + 1}</TableCell>
                                        <TableCell sx={style}>{row.ClientName}</TableCell>
                                        <TableCell sx={style}>{row.ProductName}</TableCell>
                                        <TableCell sx={style}>{row.LD_Version}</TableCell>
                                        <TableCell sx={style}>{row.LicenseTypeName}</TableCell>
                                        <TableCell sx={style}>{row.LD_UserLicenseCount}</TableCell>
                                        <TableCell sx={style}>{moment(row.LD_CreatedDate).format('DD-MM-YYYY')}</TableCell>
                                        <TableCell sx={style}>{moment(row.LD_ExpiryDate).format('DD-MM-YYYY')}</TableCell>
                                        <TableCell sx={style}>{row.Status}</TableCell>
                                    </TableRow>
                                ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    No data available.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={licenseReport.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </Box>
    );
};

export default LicenseReport;
